// import axios from 'axios'
import apiAxios from '../../services/apiAxios';

const state = {
    evento: null,
    eventos: [],
    eventosList: [],
};

const mutations = {
    'INICIALIZAR_EVENTOS'(state) {
        state.eventos = [];
        state.eventosList = [];
    },

    'EVENTO'(state, evento) {
        state.evento = evento;
    },
    'EVENTOS'(state, eventos) {
        state.eventos = eventos;
    },
    'EVENTOS_LIST'(state, eventosList) {
        state.eventosList = eventosList;
    }
};

const getters = {
    evento (state) {
        return state.evento;
    },
    eventos (state) {
        return state.eventos;
    },
    eventosList (state) {
        return state.eventosList;
    }
};

const actions = {
    getEventos ( { commit, state, rootState } ) {
        /* Si tenemos en memoria, no buscamos de nuevo los eventos */
        if (state.eventos.length == 0) {
            return new Promise((resolve, reject) => {
                commit('INICIALIZAR_EVENTOS');
                
                var token = rootState.user.tokenString;
                var params = {
                    token: token,
                    clienteId: 1
                }

                if (rootState.settings.sinConexion) {
                    var eventos = [];
                    var list = [];

                    eventos.push( {
                        id: 1,
                        nombre: 'dtv'
                    });
                    list.push('dtv');

                    commit('EVENTOS', eventos);
                    commit('EVENTOS_LIST', list);
    
                    resolve();
                } else {
                    apiAxios.get('eventos/user?token=' + token)
                    // axios.post('https://www.registrospromocionales.com.ar/api/evento/read.php', params) 
                    .then(res => {
                        var eventos = [];
                        var list = [];
                        for(let key in res.data) {
                            const evento = res.data[key];
                            if (evento) {
                                if (evento.id) {
                                    eventos.push( {
                                        id: evento.id,
                                        nombre: evento.nombre.trim()
                                    });
                                    list.push(evento.nombre.trim());
                                }
                            }
                        }             
                        commit('EVENTOS', eventos);
                        commit('EVENTOS_LIST', list);
        
                        resolve();
                    })
                    .catch(error =>  {
                        let errorMessage = 'Se produjo un error al recuperar la lista de eventos.'
            
                        if (error) {
                          if (error.response) {
                            if (error.response.data) {
                              errorMessage = error.response.data;
                            }
                          }
                        }
            
                        reject(errorMessage);
                    });
                }
            })
        }
    },
    setEvento ( { commit }, evento ) {
        commit('EVENTO', evento);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/eventos.js